import { render, staticRenderFns } from "./problemDetails.vue?vue&type=template&id=b090af50&scoped=true&"
import script from "./problemDetails.vue?vue&type=script&lang=js&"
export * from "./problemDetails.vue?vue&type=script&lang=js&"
import style0 from "./problemDetails.vue?vue&type=style&index=0&id=b090af50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b090af50",
  null
  
)

export default component.exports